import { useModule } from "src/system/useModule.tsx";
import { useClientConfig } from "src/client-config/useClientConfig.ts";

export const useModuleEditDisabled = (resource: string) => {
  const { disableEdit } = useModule(resource);
  const clientConfig = useClientConfig();
  return typeof disableEdit === "function"
    ? disableEdit({
        clientConfig,
      })
    : disableEdit;
};
